export default "__VITE_PUBLIC_ASSET__5f078b47__"